import { useState, useContext } from "react";
import {
  IonContent,
  IonPage,
  useIonRouter,
  IonItem,
  IonInput,
  IonLabel,
} from "@ionic/react";
import { ProgressContext } from "../Context";
import ProgressBar from "../components/ProgressBar";

const Tab5: React.FC = () => {
  const router = useIonRouter();
  const [isVisible, setIsVisible] = useState<any>(false);
  const [isOutline, setIsOutline] = useState<any>(false);
  const { progress, setProgress } = useContext(ProgressContext);

  const simpleNavigate = () => {
    router.push("/6", "forward", "push");
    const interval = setTimeout(() => {
      setProgress((prevProgress: number) => prevProgress + 0.25);
    }, 500);

    return () => clearTimeout(interval);
  };

  return (
    <IonPage className="scroll">
      <div
        onClick={() => setIsOutline(true)}
        style={{ height: "100%", backgroundColor: "white" }}
        className="flex flex-col  items-center"
      >
        <ProgressBar></ProgressBar>
        <h2
          className="heading1"
          style={{
            fontSize: "24px",
            paddingTop: "120px",
            fontFamily: "'poppins', sans serif",
            textAlign: "center",
          }}
        >
          Hai dolore in questo momento?
        </h2>
        <div
          style={{ fontFamily: "'poppins', sans serif", textAlign: "center" }}
          className="mt-16"
        >
          <div
            style={{ outline: isOutline ? "2px solid #49B18C" : "none" }}
            className="mainCard"
          >
            <button onClick={() => setIsVisible(true)} className="blarge">
              Si, provo dolore in questo momento
            </button>
          </div>
          <div className="mainCard">
            <button className="blarge">No, sto bene</button>
          </div>
        </div>

        {isVisible && (
          <button
            onClick={() => simpleNavigate()}
            style={{ marginTop: "32px" }}
            className="mainBtn"
          >
            Continua
          </button>
        )}
      </div>
    </IonPage>
  );
};

export default Tab5;
